import { ContactUsComponent } from './contact-us/contact-us.component';
import { WidgetComponent } from './widget/widget.component';
import { TitleComponent } from './title/title.component';
import { ReviewComponent } from './reviews/reviews.component';
import { ContactComponent } from './contact/contact.component';
import { DynamicDivComponent } from './dynamic-div/dynamic-div.component';
import { LoaderComponent } from './loader/loader.component';
import { LoginComponent } from './login/login.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { LoanSummaryComponent } from './loan-summary/loan-summary.component';
import { LoanSummaryTooltipComponent } from './loan-summary/loan-summary-tooltip.component';
import { DecisionInfoBoxComponent } from './decision-info-box/decision-info-box.component';
import { AcceptEmailVerifyComponent } from './accept-email-verify/accept-email-verify.component';
import { CtaButtonComponent } from './cta-button/cta-button.component';
import { CollapseButtonComponent } from './collapse-button/collapse-button.component';
import { EmailPromptComponent } from './email-prompt/email-prompt.component';
import { DisclosureModalComponent } from './modals/disclosures/disclosure-modal.component';
import { BankLinkingSuccessComponent } from './bank-linking-success/bank-linking-success.component';
import { BankLinkingErrorComponent } from './bank-linking-error/bank-linking-error.component';
import { UlaModalComponent } from './ula-modal/ula-modal.component';
import { UlaPdfComponent } from './ula-pdf/ula-pdf.component';
import { UlaTooltipComponent } from './ula-tooltip/ula-tooltip.component';
import { MitekTooltipComponent } from './loan-summary/mitek-tooltip.component';

export const declarations = [
  AcceptEmailVerifyComponent,
  BankLinkingErrorComponent,
  BankLinkingSuccessComponent,
  CollapseButtonComponent,
  ContactComponent,
  ContactUsComponent,
  CtaButtonComponent,
  DecisionInfoBoxComponent,
  DisclosureModalComponent,
  DynamicDivComponent,
  EmailPromptComponent,
  LoaderComponent,
  LoanSummaryComponent,
  LoanSummaryTooltipComponent,
  LoginComponent,
  MitekTooltipComponent,
  ReviewComponent,
  SectionHeaderComponent,
  TitleComponent,
  UlaModalComponent,
  UlaPdfComponent,
  UlaTooltipComponent,
  WidgetComponent
];
